module.exports = __webpack_public_path__ + "img/DS425+.26af2d59.png";